import React, { useEffect, useState } from "react";
import "./Clients.css";
import SearchIcon from "../../assets/svg/SearchIcon.svg";
import TuneIcon from "@mui/icons-material/Tune";
import AddIcon from "@mui/icons-material/Add";
import profileStaff from "../../assets/svg/defultImage.svg";

import FillterBy from "../../components/FillterBy";

import goldMadel from "../../assets/svg/goldMadel.svg";
import selverMedal from "../../assets/svg/selverMedal.svg";
import bronzeMdal from "../../assets/svg/bronzeMdal.svg";
import star from "../../assets/svg/star.svg";
import noDataFound from "../../assets/images/noDataFound.jpg";
import InfoItem from "../../components/InfoItem";

import dateFormat from "dateformat";
import { useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { useSelector } from "react-redux";

function Clients() {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [clientsData, seClientsData] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9]);
  const [errors, setErrors] = useState();
  useEffect(() => {
    setTheCommponent(window.location.href.split("/").at(-1));
  }, []);

  const [open, setOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // State for selected job titles
  const [theCommponent, setTheCommponent] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedClientsClass, setSelectedClientsClass] = useState([]);

  // Handle job title selection
  const handleJobTitleChange = (event) => {
    console.log(event);

    if (selectedClientsClass?.includes(event)) {
      setSelectedClientsClass((prev) =>
        prev.filter((title) => title !== event)
      );
      return;
    }
    setSelectedClientsClass((prev) => [...(prev || []), event]);
  };
  const clientsClass = [
    "gold",
    "silver",
    "bronze",
    "gold",
    "silver",
    "bronze",
    "gold",
    "silver",
    "bronze",
  ];
  const clientsName = [
    "Ahmed Ali Abdallah",
    "Arwa Mohamed",
    "Menna Aymen",
    "Ahmed Ali Abdallah",
    "Sara Waleed",
    "Laila Ahmed",
    "Ahmed Ali Abdallah",
    "Sara Waleed",
    "Laila Ahmed",
  ];
  // Filter staff based on selected job titles
  const filteredStaff = clientsData.filter(
    (staffMember) =>
      selectedClientsClass?.length === 0 ||
      selectedClientsClass?.includes(clientsClass[staffMember - 1])
  );

  useEffect(() => {
    if (filteredStaff.length <= 0 && errors === "no errors") {
      setErrors("no Operators Data available");
    }
    console.log(filteredStaff);
    console.log(filteredStaff);
  }, [filteredStaff]);

  return (
    <div className="Operation-Page m-4">
      <FillterBy
        open={open}
        toggleDrawer={toggleDrawer}
        handleJobTitleChange={handleJobTitleChange}
        selectedJobTitles={selectedClientsClass}
        setselectedJobTitles={setSelectedClientsClass}
        filteredStaff={filteredStaff.length}
        theCommponent={theCommponent}
      />
      <div className="staff-hader">
        <p className="my-sm-2 fs-5 my-md-0 fw-bold">Client</p>
        <div className="staff-header_edete">
          {clientsData.length > 0 ? (
            <>
              <div className="serchAndFilter-serchBar">
                <input
                  type="text"
                  className="serchAndFilter-input_staffPage"
                  placeholder={`Search for Joined in, Mobile, Email, Vehicles...`}
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery((perv) => (perv = e.target.value));
                  }}
                />
                <img
                  src={SearchIcon}
                  className="serchAndFilter-icon_staffPage"
                />
              </div>
              <div
                onClick={toggleDrawer(true)}
                className="staff-header_edete-icon mainBorder me-15"
              >
                <TuneIcon />
              </div>
            </>
          ) : null}
        </div>
      </div>
      {filteredStaff.length > 0 ? (
        <>
          <div className="client-cards">
            {filteredStaff.map((response) => {
              return (
                <div
                  onClick={() => {
                    navigate(`/clients/${response}`);
                  }}
                  key={response}
                  className="Clients-cards-card "
                >
                  <div className="staff-cards-card_title">
                    <div className="theClassOfPerson">
                      {
                        <>
                          <img
                            src={
                              clientsClass[response - 1] === "gold"
                                ? goldMadel
                                : clientsClass[response - 1] === "bronze"
                                ? bronzeMdal
                                : selverMedal
                            }
                          />
                          <p className="m-0">{clientsClass[response - 1]}</p>
                        </>
                      }
                    </div>
                    <div className="starsRatofClient">
                      {4.5}
                      <img src={star} />
                    </div>
                  </div>
                  <div className="staff-cards-card_staffInfo">
                    <div className="Clients-cards-card_staffInfo_img">
                      {response.profile_photo_path ? (
                        <img
                          className="manigTheprofileStaff"
                          src={
                            "https://estbn.com/MobileAppBackend/public" +
                            response.profile_photo_path
                          }
                        />
                      ) : (
                        <img
                          className="manigTheprofileStaff"
                          src={profileStaff}
                        />
                      )}
                    </div>
                    <div className="staff-cards-card_staffInfo_name">
                      {clientsName[response - 1]}
                    </div>
                  </div>
                  <div className="staff-cards-card_staffDate">
                    <InfoItem
                      label="Joined in"
                      value={"Jan 13, 2022" || "No Data"}
                    />
                    <InfoItem
                      label="Mobile Number"
                      value={"01003247882" || "No Data"}
                    />
                    <InfoItem
                      label="Email"
                      value={response.email || "AhmedAli@gmail.com"}
                    />
                    <InfoItem
                      label="Vehicles"
                      value={response.gender || "5 Vehicles"}
                    />
                    <InfoItem
                      label="Last activity"
                      value={response.username || " 2 July 2024  at  04:30 PM"}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : !errors ? (
        <div className="profile-loader">
          <Oval
            height={120}
            width={120}
            color="#000"
            wrapperStyle={{}}
            wrapperclassName=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="grey"
            strokeWidth={3}
            strokeWidthSecondary={3}
          />
        </div>
      ) : (
        <div className="noStaff-cards mainBorder">
          <img
            className="noStaffImg"
            src={noDataFound}
            alt="No staff members"
          />
          <p className="noDataStaff-masege">
            {errors ||
              "No Operation members have been added to this page yet. Click to add new operation members."}
          </p>
        </div>
      )}
    </div>
  );
}

export default Clients;
